/**
 * Created by odeds on 12/29/15.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var RevisionedModel = require("models/RevisionedModel");
    var ApiResources = require("assets/data/apiResources.json");
    var ApiKeyIpRangesCollection = require("manager-collections/data-sources/api-keys/ApiKeyIpRangesCollection");

    var CONST = {
        MAX_ITEMS_IN_IP_RESTRICTION_LIST: Infinity //The Back-end and the product have decided not to restrict the max number of the IP Ranges in the List
    };

    var KEYS = {
        NAME: "appName",
        DESCRIPTION: "appDescription",
        DATE_CREATED: "creationTime",
        APIKEY: "keyId",
        APIKEY_SECRET: "appSecret",
        ACCESSTOKEN: "token",
        ACCESSTOKEN_SECRET: "tokenSecret",
        ACTIVE: "enabled",
        DEVELOPER_NAME: "developerID",
        PRIVILEGES: "privileges",
        IP_RESTRICTION_RANGES: "ipRanges"
    };

    var ApiKeyModel = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        ApiKeyModel = RevisionedModel.extend({
            resource: ApiResources.ApiKeyManager.ApiKeys,
            idAttribute: KEYS.APIKEY,
            name: "ApiKeyModel",
            ipRangesCollection: null,
            ipRangesBackupArray:[],

            defaults: {
                developerID: null,
                appName: null,
                purpose: "LIVE",
                privileges: [],
                enabled: true,
                appDescription: "",
                ipRanges: []
            },

            /*
             * When using collection you'll be reaching initialize with the first param as a model json object
             * When creating a new app all params would be undefined
             **/
            initialize: function (model, options) {
                LEManager.logger.debug("enter function", "ApiKeyModel:initialize");
                if(model){
                    this.set("developerID", model.developerID);
                }
                this.listenTo(this, "sync", this.onSaved);
                RevisionedModel.prototype.initialize.call(this, model, options);
            },

            validation: {
                appName: [
                    {
                        required: true,
                        minLength: 1,
                        msg: "LEManager.manager.dataSources.edit.validation.propertyValue.required"
                    },
                    {
                        maxLength: 50,
                        msg: {
                            key: "LEManager.manager.dataSources.Api_Keys.item.length",
                            args: [50]
                        }
                    },
                    {
                        pattern: "safeString",
                        msg: "LEManager.manager.dataSources.Api_Keys.item.illegal"
                    }
                ],
                developerID: [
                    {
                        required: true,
                        minLength: 1,
                        msg: "LEManager.manager.dataSources.edit.validation.propertyValue.required"
                    },
                    {
                        maxLength: 50,
                        msg: {
                            key: "LEManager.manager.dataSources.Api_Keys.item.length",
                            args: [50]
                        }
                    },
                    {
                        pattern: "safeString",
                        msg: "LEManager.manager.dataSources.Api_Keys.item.illegal"
                    }
                ],
                "ipRanges.0.ipVersion": [
                    {
                        fn: function() {
                            if(!_.isNull(this.ipRangesCollection)) {
                                // validate hierarchy the collection
                                var ipRangesErrors = this.ipRangesCollection.validate();
                                if (!_.isEmpty(ipRangesErrors)) {
                                    return "LEManager.manager.dataSources.Api_Keys.item.ip.restriction.errors.generalError.internalError";
                                }
                            }
                        }
                    },
                    {
                        fn: function() {
                            if(!_.isNull(this.ipRangesCollection)) {
                                // validate max size of list
                                if (this.ipRangesCollection.size() > CONST.MAX_ITEMS_IN_IP_RESTRICTION_LIST) {
                                    //todo: When we will update the CONST.MAX_ITEMS_IN_IP_RESTRICTION_LIST to a real value, we will might want to change this error message
                                    return "LEManager.manager.dataSources.Api_Keys.item.ip.restriction.errors.generalError.internalError";
                                }
                            }
                        }
                    }
                ]
            },

            /*a direct fetch for a model, fetch not called when arriving from gallery only by bookmark*/
            fetch: function(options) {
                options = options || {};
                return RevisionedModel.prototype.fetch.call(this, options);
            },

            parse: function(response, options) {
                //TODO: trim unlisted privileges before incase backend will not do so
                //      use ApiKeyListModel.getUnlistedKeys()

                // snapshot the server version for both collection parse and single model fetch
                if(response.privileges){
                    this.serverVersion= response;
                    this.serverVersion.ipRanges = this.serverVersion.ipRanges || this.defaults.ipRanges;
                }
                return response;
            },
            onSaved: function(attrs, options){
                LEManager.logger.debug("ApiKeyModel has just been persisted", "ApiKeyModel:onSaved");
                this.serverVersion= this.toJSON();
            },
            /**
             * validates whether the model has all mandatory fields filled for persistance
             * @returns {boolean}
             */
            validateChangeToPersist: function(){
                LEManager.logger.debug("ApiKeyModel has been changed and is now being validated if differ than the backend copy", "ApiKeyModel:validateChangeToPersist");
                var jsonModel= this.toJSON();
                LEManager.logger.debug("serverVersion: " + (this.serverVersion && JSON.stringify(this.serverVersion.privileges)), "ApiKeyModel:validateChangeToPersist");
                LEManager.logger.debug("ApiKeyModel: " + JSON.stringify(jsonModel.privileges), "ApiKeyModel:validateChangeToPersist");
                return !_.isEqual(this.serverVersion,jsonModel);
            },
            /**
             * check: appName ; developerID; and has at least 1 privileges
             * @returns {boolean|*}
             */
            validateMandatoryFilled: function(){
                LEManager.logger.debug("ApiKeyModel checked for mandatory fields", "ApiKeyModel:validateMandatoryFilled");
                var hasPrivileges= this._getValue(KEYS.PRIVILEGES).length > 0;
                var hasName=  this._getValue(KEYS.NAME);
                var hasDeveloperId=  this._getValue(KEYS.DEVELOPER_NAME);

                //The trim is used to disable the save button in case that there are only spaces character in the input field
                hasName = !_.isNull(hasName) ? hasName.trim(): hasName;
                hasDeveloperId = !_.isNull(hasDeveloperId) ? hasDeveloperId.trim(): hasDeveloperId;

                return hasPrivileges && hasName && hasDeveloperId;
            },

            /* private getter setter */
            _getValue: function (key) {
                return this.get(key);
            },
            _setValue: function (key, value) {
                if(this._getValue(key) !== value){
                    this.set(key, value);
                }
            },


            getDateCreated: function(){
                return this._getValue(KEYS.DATE_CREATED);
            },

            isActive: function(){
                return this._getValue(KEYS.ACTIVE);
            },
            setActive: function(value){
                this._setValue(KEYS.ACTIVE, value);
            },

            getName: function(){
                return this._getValue(KEYS.NAME);
            },
            setName: function(value){
                this._setValue(KEYS.NAME, value);
            },

            getDescription: function(){
                return this._getValue(KEYS.DESCRIPTION);
            },
            setDescription: function(value){
                this._setValue(KEYS.DESCRIPTION, value);
            },

            getDeveloperName: function(){
                return this._getValue(KEYS.DEVELOPER_NAME);
            },
            setDeveloperName: function(value){
                return this._setValue(KEYS.DEVELOPER_NAME, value);
            },

            getPrivileges: function(){
                return this._getValue(KEYS.PRIVILEGES);
            },
            setPrivileges: function(value){
                return this._setValue(KEYS.PRIVILEGES, value);
            },

            getIpRestrictionRanges: function(){
                return this._getValue(KEYS.IP_RESTRICTION_RANGES);
            },

            setIpRestrictionRanges: function(value) {
               this._setValue(KEYS.IP_RESTRICTION_RANGES, value);
               this.initIpRangesCollection();
            },

            getIpRangesServerVersionList: function () {
               return this.serverVersion? this.serverVersion.ipRanges: this.defaults.ipRanges;
            },

            getIpRangesCollection: function(){
                return this.ipRangesCollection;
            },

            getIpRangesBackupArray: function(){
                return this.ipRangesBackupArray;
            },

            setIpRangesBackupArray: function(){
                this.ipRangesBackupArray = this.getIpRestrictionRanges();
            },

            initIpRangesCollection: function () {
                this.ipRangesCollection = new ApiKeyIpRangesCollection(this.getIpRestrictionRanges());
            },

            getApiKey: function(){
                return this._getValue(KEYS.APIKEY);
            },
            getApiKeySecret: function(){
                return this._getValue(KEYS.APIKEY_SECRET);
            },
            getAccessToken: function(){
                return this._getValue(KEYS.ACCESSTOKEN);
            },
            getAccessTokenSecret: function(){
                return this._getValue(KEYS.ACCESSTOKEN_SECRET);
            },

            addIpRangeItem: function (){
                var Model = this.ipRangesCollection.model;
                this.ipRangesCollection.add(new Model());
            },

            removeIpRangeItem: function(model){
                this.ipRangesCollection.remove(model);
            },

            clearIpRangesCollection: function() {
                this.ipRangesCollection.reset();
                this.pullHierChangesToModel();
            },

            pullHierChangesToModel : function () {
                this.set("ipRanges", this.ipRangesCollection.toJSON());
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    ApiKeyModel.KEYS = KEYS;

    return ApiKeyModel;
});

